import { z } from 'zod';
import { base64Validator, uuidValidator } from '#validation';
export const PendingInvitationSchema = z.object({
    invitationId: uuidValidator({
        requiredError: 'user.pendingInvitation.invitationId.required',
        formatError: 'user.pendingInvitation.invitationId.format',
    }),
    eLinkSecretByUserKey: base64Validator({
        requiredError: 'user.pendingInvitation.eLinkSecretByUserKey.required',
        invalidFormatError: 'user.pendingInvitation.eLinkSecretByUserKey.format',
    }),
});
